import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';

const FilesTableWrapper = styled('div')(
  ({ theme }) => ({
    marginBottom: 8,
    maxHeight: 600,
    borderBottom: `1px solid ${theme.palette.action.selected}`,
    overflowY: 'auto',
  }),
  addHighContrastStyles(({ theme }) => ({
    borderTop: `2px solid ${theme.palette.divider}`,
    borderBottom: `2px solid ${theme.palette.divider}`,
  })),
);

export default FilesTableWrapper;
